import { useId } from 'react';
import { Switch as Base } from '@base-ui/react/switch';
import { cn } from './cn';
import { focusRing } from './focus';

export function Switch({ label, checked, onCheckedChange, disabled, className }: { label: string; checked: boolean; onCheckedChange: (checked: boolean) => void; disabled?: boolean; className?: string }) {
  const id = useId();
  return (
    // The whole row (44 px on touch) toggles on a press, as a checkbox's does, except on the switch and its hidden input,
    // which toggle by themselves (P12a: the 36 × 20 px switch alone was the target).
    <span
      data-hit-area=""
      onClick={(e) => {
        if (disabled || (e.target instanceof Element && e.target.closest('[role="switch"], input'))) return;
        onCheckedChange(!checked);
      }}
      className={cn('inline-flex items-center gap-2 font-sans text-sm text-fg pointer-coarse:min-h-11', className)}
    >
      <Base.Root
        aria-labelledby={id}
        checked={checked}
        disabled={disabled}
        onCheckedChange={(v) => onCheckedChange(v)}
        className={cn('relative inline-flex h-5 w-9 shrink-0 items-center rounded-full bg-border-strong p-0.5 transition-colors duration-(--duration-fast) data-[checked]:bg-accent data-[disabled]:opacity-50', focusRing)}
      >
        <Base.Thumb className="block h-4 w-4 rounded-full bg-accent-fg shadow-sm transition-transform duration-(--duration-fast) data-[checked]:translate-x-4" />
      </Base.Root>
      <span id={id}>{label}</span>
    </span>
  );
}
